import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfv_J4 } from "../../../modules/Beräkningsmoduler/BFV_J4";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card } from "react-bootstrap";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J4 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfv_J4().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const funktionsKontroller = bm.funktionsKontroller;

  return (
    <div>
      BFV J4: ...Synlig endast via integration till J3
      <Funktionskontroller bfName="BFV_J4" formHook={formHook} funktionsKontroller={funktionsKontroller} />
      <BFLNote formHook={formHook} />
      <ErrorInfo info={bm.error} />
      <DebugInfo info={bm.debug} />
    </div>
  );
};

export default BFV_J4;
